import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { AutoComplete, ListEditable } from '../../../../../components'
import { debounce, THEMES } from '../../../../../utils'
import { Grid } from '@material-ui/core'
import { isEqual } from 'lodash'

/**
 * Contact Job Institution: Form Component
 */
class ManagedFunds extends PureComponent {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      funds: [],
      selected: []
    }
  }

  /**
   * Component Did Mount
   */
  componentDidMount () {
    const { managedFunds } = this.props
    this.setState({ selected: managedFunds })
  }

  /**
   * Component Did Update
   * @param prevProps
   */
  componentDidUpdate (prevProps) {
    const { managedFunds, suggestions } = this.props

    if (!isEqual(prevProps.suggestions, suggestions)) {
      this.setState({
        funds: this.getFundOptions(suggestions)
      })
    }

    if (!isEqual(prevProps.managedFunds, managedFunds)) {
      this.setState({
        selected: managedFunds
      })
    }
  }

  /**
   * ComponentWillUnmount
   */
  componentWillUnmount () {
    const { clearSuggestions } = this.props
    this.searchFunds.cancel() // reset debounce
    clearSuggestions()
  }

  /**
   * On field value change search funds
   */
  searchFunds = debounce((value) => {
    const { searchFunds, clearSuggestions } = this.props;
    (value && value.length) ?
      searchFunds({ query: value }) : clearSuggestions()
  })

  /**
   * Get fund dropdown options
   * @param suggestions
   * @returns {[]}
   */
  getFundOptions = (suggestions) => {
    const { managedFunds } = this.props
    const ids = (managedFunds || []).map((fund) => fund && fund._id)
    return (suggestions || []).filter((suggestion) => suggestion && !ids.includes(suggestion._id))
  }

  /**
   * Handle managed funds change
   * @param options
   */
  handleChange = (options) => {
    const { managedFunds, setFieldValue } = this.props
    const { funds } = this.state

    const ids = (options || []).map((option) => (option && option.value))
    const selected = (funds || []).find((fund) => fund && ids.includes(fund._id))

    if (selected) {
      setFieldValue('managedFunds', [].concat(selected, managedFunds))
    }
  }

  /**
   * On list item delete
   * @param item
   */
  onDelete = (item) => {
    const { managedFunds, setFieldValue } = this.props
    const selectedFunds = (managedFunds || [])
      .filter((funds) => (funds && funds._id) !== (item && item.value))

    setFieldValue('managedFunds', selectedFunds)
  }

  /**
   * Normalize fund option
   * @param fund
   * @returns {*}
   */
  normalize = (fund) => {
    return fund && {
      label: fund.fund_name,
      value: fund._id
    }
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const { loading, jobs } = this.props
    const { funds, selected } = this.state

    if (!jobs || !jobs.length) {
      return null
    }

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title'>Managed Funds</div>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs={6}>
            <div className='field'>
              <label className='field_label'>Search Managed Funds</label>
              <AutoComplete
                loading={loading}
                showDropdownIndicator={false}
                isMulti
                clearable={false}
                options={(funds || []).map(this.normalize)}
                isLocal={false}
                onInputChange={this.searchFunds}
                onChange={this.handleChange} />
              <ListEditable
                listKey='value'
                icon='q4i-fund-4pt'
                iconTheme={THEMES.TEAL}
                items={(selected || []).map(this.normalize)}
                onDelete={this.onDelete}/>
            </div>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

ManagedFunds.propTypes = {
  jobs: PropTypes.array,
  managedFunds: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  searchFunds: PropTypes.func.isRequired,
  suggestions: PropTypes.array,
  clearSuggestions: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired
}

ManagedFunds.defaultProps = {
  loading: false,
  managedFunds: [],
  suggestions: []
}

export default ManagedFunds